import { compareDesc, isBefore, parseISO, subDays } from 'date-fns';

import { PostInfo } from '@/components/md-blog/types';

// @ts-ignore
const mdxctx = require.context('../../demos', true, /\.(js)$/);

const today = new Date();
const yesterday = subDays(today, 1);

const isPublishingDate = (date: PostInfo['date']) => {
  const demoDate = parseISO(date);
  return (
    isBefore(demoDate, yesterday) ||
    (demoDate.toDateString() === today.toDateString() &&
      new Date().getUTCHours() >= 10)
  ); // 11:00 CET is 10:00 UTC
};

export const demos = mdxctx
  .keys()
  .map((key: string) => mdxctx(key))
  .filter((demo: PostInfo) => {
    const demoDate = parseISO(demo.date);
    return (
      isBefore(demoDate, yesterday) ||
      (isPublishingDate(demo.date) && demoDate) ||
      process.env.NODE_ENV === 'development'
    ); // 11:00 CET is 10:00 UTC
  })
  .sort((a: PostInfo, b: PostInfo) =>
    compareDesc(parseISO(a.date), parseISO(b.date))
  ) as PostInfo[];
